import { render, staticRenderFns } from "./PatientCoachingSummaryGoals.vue?vue&type=template&id=70fe7dba"
import script from "./PatientCoachingSummaryGoals.vue?vue&type=script&lang=js"
export * from "./PatientCoachingSummaryGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports